




























































import { defineComponent, reactive, watch, onMounted, PropType, inject, } from '@vue/composition-api'

import { Viewport } from '@/types/index'
import DialogSummary from '@/components/widgets/dialog/DialogSummary.vue'

export default defineComponent({
  props: {
    randomLatLng: {
      type: Object as PropType<google.maps.LatLng>,
      required: false,
    },
    round: {
      type: Number,
      required: true,
    },
    score: {
      type: Number,
      required: true,
    },
  },

  components: {
    DialogSummary,
  },

  setup(props, context) {
    const viewport: Viewport = inject('viewport') as Viewport

    const state = reactive<{
      markers: google.maps.Marker[];
      map: google.maps.Map | null;
      polyline: google.maps.Polyline | null;
      selectedLatLng: google.maps.LatLng | null;
      distance: number;
      isGuessButtonClicked: boolean;
      isMakeGuessButtonClicked: boolean;
      isSelected: boolean;
      dialogSummary: boolean;
    }>({
      markers: [],
      map: null,
      polyline: null,
      selectedLatLng: null,
      distance: 0,
      isGuessButtonClicked: false,
      isMakeGuessButtonClicked: false,
      isSelected: false,
      dialogSummary: false,  
    })

    function showMap(): void {
      document.getElementById('map')!.style.transform = "translateY(-340px)"
      state.isMakeGuessButtonClicked = true
    }

    function hideMap(): void {
      document.getElementById('map')!.style.transform = "translateY(300px)"
      state.isMakeGuessButtonClicked = false
    }

    function selectLocation(): void {
      calculateDistance()
      drawPolyline()
      putMarker(props!.randomLatLng!)
      setInfoWindow()

      google.maps.event.clearListeners(state.map!, 'click')

      state.isGuessButtonClicked = true
      state.isSelected = true

      mouseOverMap()
    }

    function putMarker(position: google.maps.LatLng): void {
      const marker = new google.maps.Marker({
        position: position,
        map: state.map!,
      })
      state.markers.push(marker)
    }

    function removeMarkers(): void {
      for (let i = 0; i < state.markers.length; i++) {
        state.markers[i].setMap(null)
      }
      state.markers = []
    }

    function calculateDistance(): void {
      state.distance = 
        Math.floor(google.maps.geometry.spherical.computeDistanceBetween(props!.randomLatLng!, state.selectedLatLng!) / 1000)
      context.emit('calculateDistance', state.distance)
    }

    function setInfoWindow(): void {
      const infoWindow = new google.maps.InfoWindow({
        content: '<b>' + state.distance + '</b> km away!'
      })
      infoWindow.open(state.map!, state.markers[0])
    }

    function drawPolyline(): void {
      state.polyline = new google.maps.Polyline({
        path: [state.selectedLatLng!, props!.randomLatLng!],
        strokeColor: '#FF0000',
      })
      state.polyline!.setMap(state.map!)
    }

    function goToNextRound(): void {
      state.selectedLatLng = null
      state.polyline!.setMap(null)
      state.isGuessButtonClicked = false
      state.isSelected = false

      if (viewport.width < 450) {
        hideMap()
      } else {
        mouseOutMap()
      }

      removeMarkers()
      context.emit('goToNextRound')
    }

    function playAgain(): void {
      state.selectedLatLng = null
      state.polyline!.setMap(null)
      state.isGuessButtonClicked = false
      state.isSelected = false
      state.dialogSummary = false

      if (viewport.width < 450) {
        hideMap()
      } else {
        mouseOutMap()
      }

      removeMarkers()
      context.emit('playAgain')
    }

    function mouseOverMap(): void {
      if (viewport.width > 450) {
        document.getElementById('map')!.style.opacity = '1.0'
        document.getElementById('map')!.style.transform = 'scale(1)'
      }
    }

    function mouseOutMap(): void {
      if (!state.isSelected && viewport.width > 450) {
        document.getElementById('map')!.style.opacity = '0.7'
        document.getElementById('map')!.style.transform = 'scale(0.75)'
      }
    }

    watch(
      () => props.randomLatLng,
      (newVal: google.maps.LatLng | undefined, oldVal: google.maps.LatLng | undefined) => {
        if (newVal !== undefined) {
          state.map!.addListener('click', (e) => {
            removeMarkers()
            putMarker(e.latLng)
            state.selectedLatLng = e.latLng
          })
        }
      }
    )

    onMounted(() => {
      state.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
          center: {lat: 37.869260, lng: -122.254811},
          zoom: 1,
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
      })      
    })

    return {
      state,
      viewport,
      mouseOverMap,
      mouseOutMap,
      hideMap,
      showMap,
      selectLocation,
      goToNextRound,
      playAgain,
    }
  }
})
